(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initNav(root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll("[data-urb-kat-pill]"));
    if (!pills.length || !("IntersectionObserver" in window)) return;
    var track = root.querySelector(".urb-kat__track");
    var active = "";

    function activate(id) {
      if (id === active) return;
      active = id;
      pills.forEach(function (pill) {
        var on = pill.getAttribute("data-urb-kat-pill") === id;
        pill.classList.toggle("is-active", on);
        if (!on) {
          pill.removeAttribute("aria-current");
          return;
        }
        pill.setAttribute("aria-current", "true");
        if (track && track.scrollWidth > track.clientWidth) {
          var left = track.scrollLeft + pill.getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({
            left: left - (track.clientWidth - pill.offsetWidth) / 2,
            behavior: reduce ? "auto" : "smooth"
          });
        }
      });
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) activate(entries[i].target.id);
      }
    }, { rootMargin: "-40% 0px -55% 0px", threshold: 0 });

    pills.forEach(function (pill) {
      var target = document.getElementById(pill.getAttribute("data-urb-kat-pill"));
      if (target) io.observe(target);
    });
  }

  function initCarousel(root) {
    var car = root.querySelector("[data-urb-kat-car]");
    var dotsWrap = root.querySelector("[data-urb-kat-dots]");
    if (!car || !dotsWrap) return;
    var cards = Array.prototype.slice.call(car.children);
    if (cards.length < 2) return;

    var dots = cards.map(function (card, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "urb-kat__dot" + (i === 0 ? " is-active" : "");
      dot.setAttribute("aria-label", window.urbStrings.showProduct + " " + (i + 1));
      dotsWrap.appendChild(dot);
      return dot;
    });

    var index = 0;
    var timer = null;
    var resumeTimer = null;
    var scrollTimer = null;
    var inView = true;

    function maxScroll() {
      return Math.max(0, car.scrollWidth - car.clientWidth);
    }

    function offsetOf(card) {
      return car.scrollLeft + card.getBoundingClientRect().left - car.getBoundingClientRect().left;
    }

    function targetFor(card) {
      return offsetOf(card) - (car.clientWidth - card.offsetWidth) / 2;
    }

    function mark(i) {
      dots.forEach(function (dot, k) { dot.classList.toggle("is-active", k === i); });
    }

    function goTo(i) {
      index = (i + cards.length) % cards.length;
      var left = Math.max(0, Math.min(targetFor(cards[index]), maxScroll()));
      car.scrollTo({ left: left, behavior: reduce ? "auto" : "smooth" });
      mark(index);
    }

    function next() {
      if (index + 1 >= cards.length || car.scrollLeft >= maxScroll() - 2) {
        goTo(0);
        return;
      }
      goTo(index + 1);
    }

    function nearest() {
      var center = car.scrollLeft + car.clientWidth / 2;
      var best = 0;
      var min = Infinity;
      cards.forEach(function (card, i) {
        var delta = Math.abs(offsetOf(card) + card.offsetWidth / 2 - center);
        if (delta < min) { min = delta; best = i; }
      });
      return best;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
    }

    function start() {
      if (reduce || timer || !inView || document.hidden) return;
      timer = setInterval(next, 4200);
    }

    function later() {
      stop();
      if (reduce) return;
      resumeTimer = setTimeout(start, 3500);
    }

    car.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (car.scrollLeft >= maxScroll() - 2) {
          index = cards.length - 1;
          mark(index);
          return;
        }
        index = nearest();
        mark(index);
      }, 120);
    }, { passive: true });

    car.addEventListener("pointerdown", stop);
    car.addEventListener("pointerup", later);
    car.addEventListener("mouseenter", stop);
    car.addEventListener("mouseleave", later);
    car.addEventListener("focusin", stop);
    car.addEventListener("focusout", later);
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { stop(); goTo(i); later(); });
    });
    var prev = root.querySelector("[data-urb-kat-prev]");
    var nextBtn = root.querySelector("[data-urb-kat-next]");
    if (prev) {
      prev.hidden = false;
      prev.addEventListener("click", function () {
        stop();
        goTo(car.scrollLeft <= 2 ? cards.length - 1 : nearest() - 1);
        later();
      });
    }
    if (nextBtn) {
      nextBtn.hidden = false;
      nextBtn.addEventListener("click", function () { stop(); next(); later(); });
    }
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else start();
    });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start(); else stop();
      }, { threshold: 0.2 }).observe(car);
    } else {
      start();
    }
  }

  function initMore(root) {
    var descs = Array.prototype.slice.call(root.querySelectorAll("[data-urb-kat-desc]"));
    if (!descs.length) return;

    function sync() {
      descs.forEach(function (desc) {
        var btn = desc.parentNode.querySelector("[data-urb-kat-more]");
        if (!btn || desc.classList.contains("is-open")) return;
        btn.hidden = desc.scrollHeight - desc.clientHeight < 4;
      });
    }

    descs.forEach(function (desc) {
      var btn = desc.parentNode.querySelector("[data-urb-kat-more]");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var open = desc.classList.toggle("is-open");
        btn.textContent = open ? btn.getAttribute("data-label-less") : btn.getAttribute("data-label-more");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    sync();
    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 200);
    }, { passive: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-urb-kat]"), function (root) {
      if (root.dataset.urbKatInit) return;
      root.dataset.urbKatInit = "1";
      initNav(root);
      initCarousel(root);
      initMore(root);
    });
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
